import logger from '@adc/logger'
import { ADGLARE_CONTENT_FETCHED } from '../constants/actionTypes'
import { fetchAdglareContent } from '../providers/adglare'

export const fetchAdContent = (dispatch, url) => {
  fetchAdglareContent(url)
    .then(response => response.json())
    .then(data => {
      // Assuming data.response.campaigns is an array of campaigns
      if (data.response?.campaigns?.length > 0) {
        // Get the HTML code from the first campaign
        const creativeData = data.response.campaigns[0].creative_data
        const htmlCode = creativeData.code
        const clickTrackingUrl = creativeData.click_url

        // Create a DOM parser
        const parser = new DOMParser()
        const doc = parser.parseFromString(htmlCode, 'text/html')

        // Find the ag (adglare) button by id
        const element = doc.getElementById('ag-action-button-id')

        if (element) {
          // Modify the onclick attribute
          element.setAttribute(
            'onclick',
            `navigator.sendBeacon('${clickTrackingUrl}')`
          )
        }

        // Convert the modified HTML back to a string
        const modifiedHTML = doc.documentElement.outerHTML

        dispatch({
          type: ADGLARE_CONTENT_FETCHED,
          value: modifiedHTML,
        })
      } else {
        logger.warn('No campaigns found in the JSON response.')
      }
    })
    .catch(error => {
      logger.warn('Error fetching adglare content data:', error)
      dispatch({
        type: ADGLARE_CONTENT_FETCHED,
        value: null,
      })
    })
}
